<template>
  <div class="custom-select" @click="toggleDropdown" v-click-outside="() => handleClickOutside()">
      <div class="selected">
      {{ selectedOption ? selectedOption: "" }}
      <svg width="11.838470" height="6.569092" viewBox="0 0 11.8385 6.56909" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs/>
          <path id="Vector" d="M10.91 0.91L5.91 5.91L0.91 0.91" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.300000" stroke-linejoin="round" stroke-linecap="square"/>
      </svg>

      </div>
      <div class="dropdown" v-if="isOpen">
      <div
          class="option"
          v-for="option in options"
          :key="option.id"
          @click.stop="selectOption(option)"
      >
          {{ option[data_name] }}
      </div>
      </div>
  </div>
</template>

<script>
export default {
name: "CustomSelect",
props: {
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: [String, Number, Object, null],
    default: null,
  },
  data_name: String,
},
data() {
  return {
    isOpen: false,
    selectedOption: null,
  };
},
methods: {
  handleClickOutside(){
      this.isOpen = false;
  },
  toggleDropdown() {
    this.isOpen = !this.isOpen;
  },
  selectOption(option) {
    this.selectedOption = option[this.data_name];;
    this.$emit("update:modelValue", option[this.data_name]);
    this.isOpen = false;
    this.$emit('change', option);
  },
},
};
</script>

<style scoped>
.custom-select.error .selected{
border: 1px solid red;
border-radius: 8px;
}
.custom-select {
  position: relative;
  height: 44px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgb(222, 230, 234);
  border-radius: 8px;
  background: rgb(255, 255, 255);
  cursor: pointer;
  color: rgb(5, 5, 5);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}
.selected {
  position: relative;
padding: 10px;
font-size: 14px;
display: flex;
justify-content: space-between;
align-items: center;
height: 100%;
}
.selected svg{
  position: absolute;
  top: 50%; /* По вертикали по центру */
  transform: translateY(-50%);
  right: 19.5px;
}
.dropdown {
position: absolute;
top: 110%;
left: 0;
width: 100%;
max-height: 200px;
overflow-y: auto;
background-color: white;
border: 1px solid rgb(222, 230, 234);
border-radius:    8px;
z-index: 10;
}
.option {
padding: 10px;
font-size: 14px;
cursor: pointer;
transition: background-color 0.2s;
color: #292929;
font-size: 15px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.09px;
}
.option:hover {
background-color: #f0f0f0;
}
</style>